var _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileMedium = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.09 3.5C5.913 3.5 5 4.437 5 5.538v12.924c0 1.101.912 2.038 2.09 2.038h9.82c1.178 0 2.09-.937 2.09-2.038V7.99L14.452 3.5zM3 5.538C3 3.308 4.832 1.5 7.09 1.5h7.505c.434 0 .85.17 1.157.473l4.769 4.708c.307.303.479.714.479 1.142v10.639c0 2.23-1.832 4.038-4.09 4.038H7.09C4.833 22.5 3 20.692 3 18.462z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.5 6.429V3h2v3.429c0 .867.704 1.571 1.571 1.571H19.5v2h-3.429A3.57 3.57 0 0 1 12.5 6.429",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 2,
  x: 7,
  y: 11,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 2,
  x: 7,
  y: 15,
  rx: 1
})));
export default SvgFileMedium;